export class DepletionMatrixFile {
    public id: number;
    public name: string;
    public productId: number;
    public userId: number;
    public userName: string;
    public uploadDate: Date;
}
